/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Linked_Group_TooltipInputs */

const en_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linked group is used to populate the source events for translation.`)
};

const fr_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe lié est utilisé pour remplir les événements source de traduction.`)
};

const de_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die verknüpfte Gruppe dient dazu, die Quellereignisse für die Übersetzung zu füllen.`)
};

const it_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo collegato viene utilizzato per popolare gli eventi sorgente per la traduzione.`)
};

const ru_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанная группа используется для заполнения исходных событий для перевода.`)
};

const es_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo vinculado se utiliza para completar los eventos de origen para la traducción.`)
};

const zh_cn2_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接组用于填充要翻译的源事件。`)
};

const ja_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクされたグループは、翻訳のソース イベントを入力するために使用されます。`)
};

const hi_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक्ड ग्रुप का उपयोग अनुवाद के लिए स्रोत घटनाओं को भरने के लिए किया जाता है।`)
};

const pt_pt2_edit_event_group_linked_group_tooltip = /** @type {(inputs: Edit_Event_Group_Linked_Group_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo vinculado é usado para preencher os eventos de origem para tradução.`)
};

/**
* | output |
* | --- |
* | "The linked group is used to populate the source events for translation." |
*
* @param {Edit_Event_Group_Linked_Group_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_linked_group_tooltip = /** @type {((inputs?: Edit_Event_Group_Linked_Group_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Linked_Group_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "de") return de_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "it") return it_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "ru") return ru_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "es") return es_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "ja") return ja_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "hi") return hi_edit_event_group_linked_group_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_linked_group_tooltip(inputs)
	return en_edit_event_group_linked_group_tooltip(inputs)
});